var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.363 24.067c0 1.62-1.281 2.933-2.865 2.933H2.865C1.283 27 0 25.687 0 24.067V2.931C0 1.311 1.283 0 2.865 0h13.633c1.583 0 2.865 1.311 2.865 2.931v21.136z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.684 4.887c0 1.387-1.098 2.51-2.452 2.51H4.626c-1.353 0-2.451-1.123-2.451-2.51 0-1.386 1.098-2.508 2.451-2.508h9.606c1.354 0 2.453 1.122 2.453 2.508zm-7.888 8.044c0-1.858-1.471-3.364-3.285-3.364s-3.286 1.506-3.286 3.364c0 1.857 1.472 3.36 3.286 3.36s3.285-1.503 3.285-3.36zm7.838 0c0-1.858-1.47-3.364-3.286-3.364-1.815 0-3.288 1.506-3.288 3.364 0 1.857 1.473 3.36 3.288 3.36 1.816 0 3.286-1.503 3.286-3.36zM8.796 21c0-1.857-1.471-3.363-3.285-3.363S2.225 19.143 2.225 21c0 1.858 1.472 3.362 3.286 3.362S8.796 22.857 8.796 21zm7.838 0c0-1.857-1.47-3.363-3.286-3.363-1.815 0-3.288 1.506-3.288 3.362 0 1.858 1.473 3.362 3.288 3.362 1.816 0 3.286-1.504 3.286-3.362z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.124 14.364v-1.252H3.893v-.641h1.23v-1.26h.62v1.26h1.233v.64H5.743v1.253h-.62zM6.305 22.4l-.868-.885-.87.892-.442-.453.873-.89-.873-.893.438-.447.871.89.87-.89.443.452-.872.89.866.888-.436.447zm5.703-9.288v-.641h2.47v.64h-2.47zm0 7.188v-.64h2.47v.64h-2.47zm0 2.067v-.637h2.47v.637h-2.47z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.5a9ebd2321c8bbee1fe09d55faec45ae.svg";
export { ForwardRef as ReactComponent };